import { apolloApi } from "@/shared/api";
// eslint-disable-next-line no-restricted-imports -- DO NOT COPY THIS LINE. See docs/lints.md.
import { ReportQueryParams } from "@suns/api/generated-client/apollo";

export async function myReportsLoader({
  authorUsername,
  status,
  offset = 0,
  limit = 20,
  teamIds,
  playerIds,
}: {
  authorUsername?: string[];
  status:
    | ReportQueryParams.status.PUBLISHED
    | ReportQueryParams.status.UNPUBLISHED;
  offset: number;
  limit: number;
  playerIds?: number[];
  teamIds?: number[];
}) {
  const response = await apolloApi.getReports({
    offset,
    limit,
    status,
    authorUsername: authorUsername,
    teamIds,
    playerIds,
    sortColumn: "statusUpdatedAt",
    sortDir: "desc",
  });

  return response;
}
